import { SelectOption } from '@/components/Form'
import { commonEnums } from './commonEnum'
import { MasterTableEnum } from './MasterTableEnum'

const ExamType: SelectOption[] = [
  {
    label: 'Part I',
    value: MasterTableEnum.MasterTableExamType.PartI
  },
  {
    label: 'Part II',
    value: MasterTableEnum.MasterTableExamType.PartII
  }
]

const YesorNoOption: SelectOption[] = [
  {
    value: commonEnums.YesorNo.Yes,
    label: 'Yes'
  },
  {
    value: commonEnums.YesorNo.No,
    label: 'No'
  }
]

const RoleOption: SelectOption[] = [
  {
    value: MasterTableEnum.Role.President,
    label: 'President'
  },
  {
    value: MasterTableEnum.Role.Chairman,
    label: 'Chairman, BVTS'
  },
  {
    value: MasterTableEnum.Role.Chief,
    label: 'Chief Censor'
  }
]

export const masterTableOptions = { ExamType, YesorNoOption, RoleOption }
